import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/speedlimitareaanalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/speedlimitareaanalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/speedlimitareaanalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGrouplocalalarmlimitspeedlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/speedlimitareaanalysisregulation/speedlimitareaanalysisregulation/updatevehicleInfoGrouplocalalarmlimitspeedlimit/' + params.vehicleInfoGroupids + '/' + params.localalarmlimit + '/' + params.speedlimit + '/' + params.speedlimitname + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datelocalalarmlimitAndspeedlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/speedlimitareaanalysisregulation/speedlimitareaanalysisregulation/' + params.terminalNum + '/' + params.localalarmlimit + '/' + params.speedlimit + '/' + params.speedlimitname + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

